import { render, staticRenderFns } from "./total-calls.vue?vue&type=template&id=53c51430&"
import script from "./total-calls.vue?vue&type=script&lang=js&"
export * from "./total-calls.vue?vue&type=script&lang=js&"
import style0 from "./total-calls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports